import { StarsButton, Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { closeDocVerify } from '@swf/core/utils/postMessages';

import {
  TXTCLI_N0_hours,
  TXTCLI_OK,
  TXTCLI_Thank_youX,
  TXTWCL_In_the_meantimeX_please_enjoy__ELL,
  TXTWCL_Please_allow_up_to_N0_to_proce_ELL,
  TXTWCL_WeXll_check_this_as_soon_as_we_ELL,
  TXTWCL_We_will_review_and_come_back_t_ELL
} from './ConfirmationMessage.messages.json';
import styles from './ConfirmationMessage.scss';

interface Props {
  showButton?: boolean;
  onComplete?(): void;
}

const ConfirmationMessage: React.FC<Props> = ({ onComplete, showButton }) => {
  const isRealMoneyOK = useSelector(select.account.isRealMoneyOK);
  const isAgeVerified = useSelector(select.account.isAgeVerified);
  const isAuthVerified = useSelector(select.account.isAuthVerified);

  const { localSettings, modal } = useDispatch<Dispatch>();

  const closeVerification = () => {
    if (onComplete) {
      onComplete();
      return;
    }

    closeDocVerify();
    modal.close('/auth/docverify');
  };

  useEffect(() => {
    localSettings.set({ documentsSubmitted: true });
  }, [localSettings]);

  return (
    <>
      <StarsInfo type="confirmation">
        <Translation tagName="b" {...TXTCLI_Thank_youX} />
        <p className={styles.message}>
          {isAgeVerified && isAuthVerified && isRealMoneyOK ? (
            <>
              <Translation {...TXTWCL_We_will_review_and_come_back_t_ELL} />{' '}
              <Translation {...TXTWCL_In_the_meantimeX_please_enjoy__ELL} />
            </>
          ) : (
            <>
              <Translation {...TXTWCL_WeXll_check_this_as_soon_as_we_ELL} />{' '}
              <Translation
                values={{ 0: <Translation values={{ 0: 24 }} {...TXTCLI_N0_hours} /> }}
                {...TXTWCL_Please_allow_up_to_N0_to_proce_ELL}
              />
            </>
          )}
        </p>
      </StarsInfo>
      {showButton && (
        <StarsButton
          block
          translation={TXTCLI_OK}
          className={styles.button}
          onClick={closeVerification}
        />
      )}
    </>
  );
};

export default ConfirmationMessage;
